import { ROUTES } from "@vv/types";
import { Button, FullPageStatus } from "@vv/ui";
import { useNavigate } from "react-router-dom";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <FullPageStatus
      variant="empty"
      title="Page not found"
      description="The page you're looking for doesn't exist or has been moved."
      action={
        <Button variant="contained" onClick={() => navigate(ROUTES.home)}>
          Back to home
        </Button>
      }
    />
  );
}
